import React, { createContext, useContext } from 'react';

const EditorContext = createContext();

export const useEditor = () => {
  const context = useContext(EditorContext);
  if (!context) {
    throw new Error('useEditor must be used within EditorProvider');
  }
  return context;
};

export const EditorProvider = ({ children, ...actions }) => {
  return (
    <EditorContext.Provider value={actions}>
      {children}
    </EditorContext.Provider>
  );
};